// Site colour trial: true = white site (see src/theme-white.css), false = original black sections.
export const WHITE_THEME = true;

if (WHITE_THEME) document.documentElement.classList.add("tw-white");
